<template>
  <div>
    <app-header />
    <div class="breadcrumb">
      <div class="breads">
        <span
          class="bread-inner"
          @click="$router.push({
            path: '/curriculumResource',
            query: {
              tabs: query.tabs
            }
          })"
        ><i class="el-icon-arrow-left"></i> 返回</span>
        <span class="bread-current">课程详情</span>
      </div>
    </div>
    <div class="e-content">
      <div class="video-container">
        <div class="video-docx">
          <div class="title">{{ list.courseName }}</div>
          <div class="video-player">
            <div
              v-if="transcoder"
              class="play-trans"
            >
              <img
                src="@/assets/images/transcoder.png"
                alt=""
              />
              <div class="text">资源转码失败，请下载文件查看内容</div>
            </div>
            <div
              class="play-type"
              v-else
            >
              <template v-if="
                  type == 'mp4' ||
                  type == 'MP4' ||
                  type == 'mov' ||
                  type == 'MOV'
                ">
                <video-player
                  class="video-players vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="playerOptions"
                  @play="handlePlay($event)"
                  @pause="handlePause($event)"
                  @ended="handleEnded($event)"
                />
              </template>
              <template v-else-if="type == 'pptx' || type == 'ppt'">
                <div class="imgbox">
                  <img
                    v-for="(item, index) in pptImg"
                    :key="index"
                    :src="item"
                    alt=""
                  />
                </div>
              </template>
              <template v-else>
                <div
                  v-show="resetPdf"
                  class="pdf-over"
                  ref="scollContain"
                  id="testScroll"
                >
                  <vue-pdf
                    v-for="i in totalPdf"
                    :key="i"
                    :src="src"
                    :page="i"
                    @num-pages="pageCount = $event"
                    @page-loaded="currentPage = $event"
                    @loaded="loadPdfHandler"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="catalogue">
          <div class="title">
            <span>本课资源</span>
            <div
              class="btn"
              @click="handleDownPackAge"
              v-if="query.authorizationType==1"
            >
              <p>一键下载</p>
            </div>
          </div>
          <div class="content">
            <div
              class="list"
              v-for="(v, i) in arrayData"
              :key="v.id"
              :class="{ active: currentShowIndex == i }"
            >
              <div
                class="left"
                @click="handleClick(v, i)"
              >
                <img
                  class="icons"
                  v-if="
                    v.fileSuffix == 'mp4' ||
                    v.fileSuffix == 'MP4' ||
                    v.fileSuffix == 'mov' ||
                    v.fileSuffix == 'MOV'
                  "
                  src="../../assets/images/mp4.png"
                  alt=""
                />
                <img
                  class="icons"
                  v-else-if="
                    v.fileSuffix == 'doc' ||
                    v.fileSuffix == 'DOC' ||
                    v.fileSuffix == 'docx' ||
                    v.fileSuffix == 'DOCX'
                  "
                  src="../../assets/images/word.png"
                  alt=""
                />
                <img
                  class="icons"
                  v-else-if="v.fileSuffix == 'pdf' || v.fileSuffix == 'PDF'"
                  src="../../assets/images/pdf.png"
                  alt=""
                />
                <img
                  class="icons"
                  v-else-if="
                    v.fileSuffix == 'xls' ||
                    v.fileSuffix == 'XLS' ||
                    v.fileSuffix == 'xlsx' ||
                    v.fileSuffix == 'XLSX'
                  "
                  src="../../assets/images/excel.png"
                  alt=""
                />
                <img
                  class="icons"
                  v-else
                  src="../../assets/images/ppt.png"
                  alt=""
                />
                <span class="text ellipsis">{{ v.fileName }}</span>
              </div>
              <div
                class="right"
                v-if="query.authorizationType==1"
              >
                <span
                  class="down"
                  ref="downFile"
                  @click="handleDown(v)"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="introduction">
        <div class="introduction-title">
          <i></i>
          <span>资源介绍</span>
        </div>
        <div class="content">
          <div class="desc">
            <div class="box">
              <img
                src="../../assets/images/icon-1.png"
                alt=""
              />
              <span>课程介绍</span>
            </div>
            <p v-html="translationContent(list.courseIntroduction)"></p>
          </div>
          <div class="desc">
            <div class="box">
              <img
                src="../../assets/images/icon-2.png"
                alt=""
              />
              <span>教学目标</span>
            </div>
            <p v-html="translationContent(list.teachingGoal)"></p>
          </div>
          <div class="desc">
            <div class="box">
              <img
                src="../../assets/images/icon-3.png"
                alt=""
              />
              <span>教学重点</span>
            </div>
            <p v-html="translationContent(list.teachingFocus)"></p>
          </div>
          <div class="desc">
            <div class="box">
              <img
                src="../../assets/images/icon-4.png"
                alt=""
              />
              <span>教学难点</span>
            </div>
            <p v-html="translationContent(list.teachingDifficult)"></p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AppHeader from "@/components/appHeader";
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
// import "video.js/dist/lang/zh-CN.js";
import vuePdf from "vue-pdf";
export default {
  data () {
    return {
      list: { courseName: "" },
      type: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
      src: "", // pdf文件地址
      playerOptions: {
        playbackRates: [0.75, 1.0, 1.25, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      arrayData: [],
      contentList: [],
      numPages: 0,
      totalPdf: 0,
      resetPdf: false,
      currentShowIndex: 0,
      pptImg: [],
      transcoder: false, // 是否转码成功
      entryTime: Date.now(), // 进入当前页时间
      playSourceId: '', // 当前观看资源ID
      playStartTime: '', // 当前观看资源开始时间
      fileDownVal: null, // 单个文件下载的内容
      downType: null, // 1 批量下载
    };
  },
  components: {
    videoPlayer,
    vuePdf,
    AppHeader
  },
  computed: {
    query () {
      return this.$route.query;
    },
    player () {
      return this.$refs.videoPlayer.player;
    },
  },
  created () {
    this.viewCourse();
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll () {
      let divScroll = document.getElementById("testScroll");
      if (divScroll) {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        let scrollTop = divScroll.scrollTop;
        //变量windowHeight是可视区的高度
        let windowHeight = divScroll.clientHeight;
        //变量scrollHeight是滚动条的总高度
        let scrollHeight = divScroll.scrollHeight;
        if (
          scrollTop + windowHeight >= scrollHeight - 20 &&
          this.totalPdf < this.numPages
        ) {
          this.totalPdf += 1;
        }
      }
    },
    // this.$Base64.decode(
    viewCourse () {
      // courseId:35
      console.log('id:');
      console.log(this.query.id)
      if (Number(this.query.id) === 35) {
        this.list = {
          "id": 35,
          "courseName": "考试焦虑怎么办",
          "courseType": 1,
          "subjectCode": "02",
          "courseSubject": "学会学习",
          "courseIntroduction": "考试焦虑是指因考试压力过大而引发的系列异常生理心理现象，是考生中常见的一种以担心、紧张或忧虑为特点的复杂而延续的情绪状态。考试焦虑严重影响了学生考试的发挥和身心健康，阻碍学生的学习成长。因此，帮助学生正确对待考试焦虑，培养良好的学习观念是十分必要的。",
          "courseCoverId": "1",
          "coverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/7d7a6d52-569d-44bb-bf57-eb58353c2b1a/【封面】考试焦虑怎么办.png",
          "courseCoverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/2021/10/22/11/17ac19e954-3541-42c6-b052-5ed1d2ea6318.png",
          "courseZipId": "4826",
          "segmentCode": "02",
          "segmentName": "高中",
          "gradeCode": "10,11,12",
          "gradeName": "高一，高二，高三",
          "segmentViewFlag": 0,
          "designBackground": null,
          "teachingGoal": "（一）知识目标\n了解考试焦虑的表现形式，考试焦虑产生的原因以及不同程度的焦虑会给人带来怎样的影响。\n（二）能力目标\n考前或考试时能够觉察自己焦虑情绪的产生，能够用合理的方法调节自己的焦虑情绪。\n（三）情感与价值观目标\n能够正确看待考试的积极作用，能够坦然面对和接纳自己面对考试时的焦虑情绪，从而帮助自己进一步调节情绪。\n",
          "teachingFocus": "学生能够掌握调节考试焦虑的方法与策略。",
          "teachingDifficult": "引导学生能够坦然面对和接纳自己考试焦虑的情绪，能够积极看待考试的作用。",
          "zipPath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zNThhMGQ0MzFjLTI0Y2QtNDJmYy1hNDE2LTI1NjBhY2IwNjk4Ny/ogIPor5XnhKbomZHmgI7kuYjlip4uemlw",
          "zipName": "考试焦虑怎么办.zip",
          "fileVoList": [
            {
              "id": "4828",
              "fileName": "【1】考试焦虑怎么办完整版.MP4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8xOS81NTRiNjg2MTFlLTE1YzgtNDJkOC1hYzlkLWQ3ZTA4YTAwMTdiYy/jgJAx44CR6ICD6K+V54Sm6JmR5oCO5LmI5Yqe5a6M5pW054mILk1QNA==",
              "fileSuffix": "MP4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4830",
              "fileName": "【2】考试焦虑的成因与表现.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8wMDUwMDhjMDNjLTk4Y2ItNDkzOS1iMDNmLTc2OWNmMjNlNDA2NS/jgJAy44CR6ICD6K+V54Sm6JmR55qE5oiQ5Zug5LiO6KGo546wLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4832",
              "fileName": "【3】如何正确看待考试焦虑.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8wMWFiZmJmMDA1LTQ3NzEtNDFhZi04YzNiLTNkMzJjZDlmYjVkNS/jgJAz44CR5aaC5L2V5q2j56Gu55yL5b6F6ICD6K+V54Sm6JmRLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4834",
              "fileName": "【4】如何应对考试焦虑.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8wMThlMmMxZmJlLTE5ZjEtNGY4Ni05NDcyLTI3NjNlNDhhZWFiMi/jgJA044CR5aaC5L2V5bqU5a+56ICD6K+V54Sm6JmRLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4836",
              "fileName": "考试焦虑怎么办-教案.docx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC80OTMzNzkyNDgwLTRlYzgtNDJjZS05NjdhLTNkMDc3YTA1YmYyMC/ogIPor5XnhKbomZHmgI7kuYjlip4t5pWZ5qGILmRvY3g=",
              "fileSuffix": "docx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8wOS8yOS8xNS8wMTE1OGM1NTM4LTI0MzktNGFjMS1iMjhkLWViMGM3MDdmNjI3Nl9kb2N4YzI2Yzc3MGYtMjBhOS00MTliLWIxZjctZThmNGJmZjYyOTY3LnBkZg==",
              "totalPage": null,
              "convId": "61964bfdd094fe7a8c7ac21f"
            },
            {
              "id": "4838",
              "fileName": "考试焦虑怎么办-课程ppt.pptx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8wODFmZmE0ZGU4LTg3N2MtNGEzZi04ZWIxLWM3NWQwYWRkZDJlMS/ogIPor5XnhKbomZHmgI7kuYjlip4t6K++56iLcHB0LnBwdHg=",
              "fileSuffix": "pptx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vYWF2cC1maWxlLWNvbnZlcnQtcHJvZC/ogIPor5XnhKbomZHmgI7kuYjlip4t6K++56iLcHB0LzJmYTE5YTgzOGY5NjQxODVhMjZkYTFlMzE0MzA2ZTk2LzliNWFmZWU1NzNiNDQ4ZDJhOGRhMzYzMjA3ZjAwMWU3L3ByZXNlbnRhdGlvbi9kYXRhL2JpZzEucG5n",
              "totalPage": 26,
              "convId": "602173c023214c3fa00509ab226e08cb"
            }
          ]
        };
      } else if (Number(this.query.id) === 41) {
        this.list = {
          "id": 41,
          "courseName": "成为网络世界的合格公民",
          "courseType": 1,
          "subjectCode": "04",
          "courseSubject": "情绪发展",
          "courseIntroduction": "随着互联网技术的飞速发展，我们的社会就已然变成了一个网络社会。可以说，看似虚拟的空间，其实正在变成我们的日常生活。现在是网络时代，学生生活也是社会生活的一部分。如何引导学生合理使用网络，使其成为网络世界合格的公民，是学校教育的重要内容和目标。",
          "courseCoverId": "1",
          "coverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/2021/12/16/17/511b6f7f16-d877-4633-aa6c-152818f4e4f3/截屏2021-12-16下午5.50.56.png",
          "courseCoverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/2021/10/22/11/17ac19e954-3541-42c6-b052-5ed1d2ea6318.png",
          "courseZipId": "2680",
          "segmentCode": "02",
          "segmentName": "高中",
          "gradeCode": "10,11,12",
          "gradeName": "高一，高二，高三",
          "segmentViewFlag": 0,
          "designBackground": null,
          "teachingGoal": " 知识目标：了解网络使人“上瘾”的原因及过度使用网络的危害。\n 能力目标：能合理使用网络，避免网络成瘾，抵御网络诱惑。\n 情感与价值观目标：意识到合理使用网络对自身发展及人类社会的价值，培养良好的使用网络习惯。\n",
          "teachingFocus": "了解正确使用网络的方法，能抵御网络诱惑。",
          "teachingDifficult": "抵御网络诱惑、恰当使用网络是教学的难点。",
          "zipPath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8xOWEzOThlMWE3LThlYTMtNDczYS05OTkxLTEzNDk4NWRkOGNmYy/nvZHnu5zmiJDnmL4t5YGa572R57uc5LiW55WM55qE5ZCI5qC85YWs5rCRLnppcA==",
          "zipName": "网络成瘾-做网络世界的合格公民.zip",
          "fileVoList": [
            {
              "id": "2681",
              "fileName": "【1】网络世界的合格功能完整版.MP4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8yNTU0Mjc2NmI4LTdkZGItNGEwZi04YTVjLTEyMjhlZDVhZjVjMS/jgJAx44CR572R57uc5LiW55WM55qE5ZCI5qC85Yqf6IO95a6M5pW054mILk1QNA==",
              "fileSuffix": "MP4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "2682",
              "fileName": "【2】为什么会沉迷网络.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zMTZhODM0MDUxLWFiZmItNDNjZi1hNTVkLTY0NGM1YTBhNzliYS/jgJAy44CR5Li65LuA5LmI5Lya5rKJ6L+3572R57ucLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "2683",
              "fileName": "【3】网络的利与弊.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zMjVlNzY3ZDgzLWVjYTMtNDgxOS1hMWRiLWRmYzI0MzUyYTFmZS/jgJAz44CR572R57uc55qE5Yip5LiO5byKLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "2684",
              "fileName": "【4】如何合理使用网络.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zMjFjOTIxYWE5LTliNTUtNDc0YS1hMjdhLThhODE5MTdhYTA0ZS/jgJA044CR5aaC5L2V5ZCI55CG5L2/55So572R57ucLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "2685",
              "fileName": "【教案】做网络世界的合格公民.docx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zMjhhOTk3NjZiLWViOGYtNDg1Ni1hYTE4LThiMDVjZTA2Njg3Ny/jgJDmlZnmoYjjgJHlgZrnvZHnu5zkuJbnlYznmoTlkIjmoLzlhazmsJEuZG9jeA==",
              "fileSuffix": "docx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8wMS8yMy80NzU1Y2JiOTRlLTMyODktNGMwNi1iOWM4LTE5ODRhNmUyMDIxOV9kb2N4ZWQ4ZTczZWMtMDZlOC00OGI1LWE1NzUtM2FhMGZjMjAyZmI0LnBkZg==",
              "totalPage": null,
              "convId": "619647f8e9475c51039fb87d"
            },
            {
              "id": "2686",
              "fileName": "【课件】做网络世界的合格公民.pptx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zMjcyNTA1MzY4LTM5ZTgtNDc1Ny1iMDU0LTBlMTVlNWRmYTA5ZC/jgJDor77ku7bjgJHlgZrnvZHnu5zkuJbnlYznmoTlkIjmoLzlhazmsJEucHB0eA==",
              "fileSuffix": "pptx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vYWF2cC1maWxlLWNvbnZlcnQtcHJvZC/jgJDor77ku7bjgJHlgZrnvZHnu5zkuJbnlYznmoTlkIjmoLzlhazmsJEvMWFiOWI5NzRjMzg2NGI4NGIzM2EzNDM0MDU4MTgyZDMvODA4NTI5NzM0ZTIyNDVjN2JkYTI1OWQ2NjUxMTEyOWQvcHJlc2VudGF0aW9uL2RhdGEvYmlnMS5wbmc=",
              "totalPage": 32,
              "convId": "15cbaa4492dc44b4bff8eb6897c6d4a1"
            }
          ]
        }
      } else if (Number(this.query.id) === 43) {
        this.list = {
          "id": 43,
          "courseName": "学会沟通",
          "courseType": 1,
          "subjectCode": "03",
          "courseSubject": "人际交往",
          "courseIntroduction": "在生活中，沟通无处不在，它既是人与人之间传递信息的基本过程，也是人与人之间建立信任关系的重要途径。良好的沟通可以消除误解，缓解情绪，激励斗志，改善关系。",
          "courseCoverId": "4",
          "coverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/2021/12/16/17/52df95402a-417c-4fbf-8aa6-9dc58038577a/截屏2021-12-16下午5.51.16.png",
          "courseCoverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/2021/10/22/11/182b82bc09-5fad-47cb-943f-54bc581c8a9d.png",
          "courseZipId": "4548",
          "segmentCode": "02",
          "segmentName": "高中",
          "gradeCode": "10,11,12",
          "gradeName": "高一,高二,高三",
          "segmentViewFlag": 0,
          "designBackground": null,
          "teachingGoal": "（一）知识目标：了解良好沟通的界定以及影响良好沟通的关键因素。\n（二）能力目标：能够在日常学习生活中尝试使用表达与倾听的技巧方法。\n（三）情感与价值观目标：意识到良好沟通对于建立和维持人际关系的重要意义，激发同学之间交往的主动性与积极性。",
          "teachingFocus": "了解影响良好沟通的多元因素。1",
          "teachingDifficult": "能够尝试将表达与倾听的沟通技巧灵活地应用到生活中。",
          "zipPath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zMzBlZTMwMjM2LTRlNDMtNDMzNS1iNDZjLTg2OTc2OWI3MzQyNy/lrabkvJrmsp/pgJouemlw",
          "zipName": "学会沟通.zip",
          "fileVoList": [
            {
              "id": "4549",
              "fileName": "【1】学会沟通完整版视频.MP4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zNTMxNTY1Y2IyLWM4ZDAtNGM4OS1iZTBmLTc1ZTQ3YzA1ZTFlNC/jgJAx44CR5a2m5Lya5rKf6YCa5a6M5pW054mI6KeG6aKRLk1QNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4550",
              "fileName": "【2】课程引入.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zNzM5YTg1NTU5LTc2MDMtNDU3ZS04ZTMzLWQ2ODExMmU5YjNkOS/jgJAy44CR6K++56iL5byV5YWlLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4551",
              "fileName": "【3】如何倾听与沟通.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zN2ZhYWY3MjBiLWM5NmEtNGZmMS04YzVjLWNiM2IwMjU2NjcxYy/jgJAz44CR5aaC5L2V5YC+5ZCs5LiO5rKf6YCaLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4552",
              "fileName": "【4】关于沟通的小故事.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zNzQ3OGE5MjExLTRjNWMtNGVjZS04ZWM4LTA0Yzc2MjlhZTAxZS/jgJA044CR5YWz5LqO5rKf6YCa55qE5bCP5pWF5LqLLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4553",
              "fileName": "【教案】学会沟通.docx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zODIzYThlOThhLTAzODQtNGI3Zi1iYWI2LWNmNDQ3ODI2Y2IyYi/jgJDmlZnmoYjjgJHlrabkvJrmsp/pgJouZG9jeA==",
              "fileSuffix": "docx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zODIzYThlOThhLTAzODQtNGI3Zi1iYWI2LWNmNDQ3ODI2Y2IyYi/jgJDmlZnmoYjjgJHlrabkvJrmsp/pgJpfZG9jeGFhNWRlMjk4LWIzZjYtNGMyYy1hNGMzLTYxNTJjMjRlNmQ3NS5wZGY=",
              "totalPage": null,
              "convId": "61964945d094fe7a8c7a1943"
            },
            {
              "id": "4554",
              "fileName": "【课件】学会沟通 .pptx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8zODA3MGVjYzQ5LTlmODItNGExYy1hYWFmLWE4NThkYWFjZDZjMC/jgJDor77ku7bjgJHlrabkvJrmsp/pgJoucHB0eA==",
              "fileSuffix": "pptx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vYWF2cC1maWxlLWNvbnZlcnQtcHJvZC/jgJDor77ku7bjgJHlrabkvJrmsp/pgJovMWYxZTk3ZmJkNjA4NGViNzk1NDU5NTlmYmU5MmJjNWQvMmQwODYwNzNhNzRlNDJkNGFlNDgzNTJmNjg2MzJhNzMvcHJlc2VudGF0aW9uL2RhdGEvYmlnMS5wbmc=",
              "totalPage": 34,
              "convId": "3a97afedcfe643a696065212819bd00e"
            }
          ]
        }
      } else if (Number(this.query.id) === 45) {
        this.list = {
          "id": 45,
          "courseName": "遇见未知的自己",
          "courseType": 1,
          "subjectCode": "01",
          "courseSubject": "认识自我",
          "courseIntroduction": "本课的教学核心是帮助学生探索自我、体验自我，学习认识自我的方法，形成客观的自我评价，并且正确的看待自我，悦纳自我。初步的自我探索是形成客观的自我认识重要的过程，是之后兴趣、能力、职业探索的基础。\t",
          "courseCoverId": "1",
          "coverPath": "https://test.download.cycore.cn/CSB-decompression-planet-service/67bbca7f-af1d-4443-9461-433fcfa5b825/【封面】遇见未知的自己.png",
          "courseCoverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/2021/10/22/11/17ac19e954-3541-42c6-b052-5ed1d2ea6318.png",
          "courseZipId": "4744",
          "segmentCode": "01",
          "segmentName": "初中",
          "gradeCode": "07,08,09",
          "gradeName": "初一，初二，初三",
          "segmentViewFlag": 0,
          "designBackground": null,
          "teachingGoal": "（一）知识目标：了解自我的分类和自我认识的方法，客观地进行自我评价以及认识他人评价。\n（二） 能力目标：将认识自我的方法运用到生活中，调整自己的行为，展现和发展更好地自己。\n（三）情感目标：产生认识自我的兴趣，体验认识他人评价的好奇感，对自己充满期待，悦纳自我。\n",
          "teachingFocus": "客观的评价自我，乔哈里窗的使用",
          "teachingDifficult": "悦纳自我\n 难点突破：通过故事两则引发学生思考，让学生认识到我们对自己的评价可能存在误差，在客观认识自我基础上，要积极地肯定自我。",
          "zipPath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8yNTc5MThiY2I3LWU0MmMtNDgzZC1hZTA5LWIwYjQ5NzVjYjkxOS/mgqbnurPoh6rmiJEt6YGH6KeB5pyq55+l55qE6Ieq5bexLnppcA==",
          "zipName": "悦纳自我-遇见未知的自己.zip",
          "fileVoList": [
            {
              "id": "4745",
              "fileName": "【1】遇见未知的自己完整版.MP4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8xNTBhNDExYzc0LTgyN2MtNDc0OC05ODhiLTAyYjhkNDdhNzFjZC/jgJAx44CR6YGH6KeB5pyq55+l55qE6Ieq5bex5a6M5pW054mILk1QNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4746",
              "fileName": "【2】我眼中的自己.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8xOWNiNzFkNWY5LTQ3MjctNDVhZS1hZmQ1LWU3ODY1ZmUzNTcxNC/jgJAy44CR5oiR55y85Lit55qE6Ieq5bexLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4747",
              "fileName": "【3】他人眼中的我.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8yMWQwMjUxNTc3LWYyOGQtNGFmMC1hYTAwLTA0OGRjYTE0YzEyYi/jgJAz44CR5LuW5Lq655y85Lit55qE5oiRLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4748",
              "fileName": "【4】我们应该如何看待自己.mp4",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8yMjc4OGYzMmFlLTZjMzEtNDk2Ni1hZTNiLTJmMDlkMDljOGU3NC/jgJA044CR5oiR5Lus5bqU6K+l5aaC5L2V55yL5b6F6Ieq5bexLm1wNA==",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4749",
              "fileName": "【教案】遇见未知的自己.docx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8yNGFiM2FkNDQzLTViNmEtNDkzNy1hZDAyLWU2ZDEzNGVkOWI4Yy/jgJDmlZnmoYjjgJHpgYfop4HmnKrnn6XnmoToh6rlt7EuZG9jeA==",
              "fileSuffix": "docx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8wMi8wMC8wMTZjYTM4YWUwLTIwY2QtNDZiMy1hMzYwLTIxNzg2MDg5MzMyMV9kb2N4YWU2YmEwMzUtNWE3MC00MGM3LTgwZWYtNzUwNTdiZTE3ZWYxLnBkZg==",
              "totalPage": null,
              "convId": "619648627d257df4626e418b"
            },
            {
              "id": "4750",
              "fileName": "【课件】遇见未知的自己.pptx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8yNGEyYmMyMzA3LTFkNjUtNDBiOC05YzE4LTM1ZDdiYTEwOTMwYy/jgJDor77ku7bjgJHpgYfop4HmnKrnn6XnmoToh6rlt7EucHB0eA==",
              "fileSuffix": "pptx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vYWF2cC1maWxlLWNvbnZlcnQtcHJvZC/jgJDor77ku7bjgJHpgYfop4HmnKrnn6XnmoToh6rlt7EvZGRiNmU2ZTJhOGYwNGJlNThhZmU5MTFiMjMwNWJkNWMvOGRmNmQwZGFmYjJhNDkzZGIyZDM4MGYxZjg5OTRkYjkvcHJlc2VudGF0aW9uL2RhdGEvYmlnMS5wbmc=",
              "totalPage": 22,
              "convId": "09adf747c40741eaa5102acfcdd59ed5"
            }
          ]
        }
      } else if (Number(this.query.id) === 47) {
        this.list = {
          "id": 47,
          "courseName": "迈好中学的第一步",
          "courseType": 1,
          "subjectCode": "06",
          "courseSubject": "社会与适应",
          "courseIntroduction": "对于刚入学的新生来说，能够适应新的环境和集体是一个新的挑战。所以帮助学生完成身份的转变，适应生活中的变化，不仅可以帮助学生迈出中学的第一步，也可以陪伴他们成长的每一步。",
          "courseCoverId": "1",
          "coverPath": "https://test.download.cycore.cn/CSB-decompression-planet-service/87cc3e38-778c-4890-9ff7-01100644efd1/截屏2022-02-21上午12.36.58.png",
          "courseCoverPath": "https://bj.download.cycore.cn/CSB-decompression-planet-service/2021/10/22/11/17ac19e954-3541-42c6-b052-5ed1d2ea6318.png",
          "courseZipId": "4705",
          "segmentCode": "01",
          "segmentName": "初中",
          "gradeCode": "07,08,09",
          "gradeName": "初一，初二，初三",
          "segmentViewFlag": 0,
          "designBackground": null,
          "teachingGoal": "（一）知识目标：了解中学与小学的不同，掌握适应中学生活的方法。\n（二）能力目标：通过活动熟悉新校园，认识、熟悉新同学，加深对彼此的了解。\n（三）情感与价值观目标：树立积极态度，在心理上做好面对中学生活的准备，并对其充满期待。",
          "teachingFocus": "适应中学的学习生活，并对接下来的生活充满期待。",
          "teachingDifficult": "掌握适应新生活的方法，积极调整自己。",
          "zipPath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8yMC8xMGE1NjNkZmEyLWIzYzItNDA5NS05OTRlLTRlNzU2NDZjMWFlNi/lrabkvJrpgILlupQt6L+I5aW95Lit5a2m56ys5LiA5q2lLnppcA==",
          "zipName": "学会适应-迈好中学第一步.zip",
          "fileVoList": [
            {
              "id": "4706",
              "fileName": "学会适应-迈好中学第一步完整版.mp4",
              "filePath": "aHR0cHM6Ly90ZXN0LmRvd25sb2FkLmN5Y29yZS5jbi9DU0ItZGVjb21wcmVzc2lvbi1wbGFuZXQtc2VydmljZS9kYTczZDlhMS02OTk5LTQ5YTQtYjhjZC00MzZkYjE5NTYyMmMv5a2m5Lya6YCC5bqULei/iOWlveS4reWtpuesrOS4gOatpeWujOaVtOeJiC5tcDQ=",
              "fileSuffix": "mp4",
              "transformUrl": null,
              "totalPage": null,
              "convId": null
            },
            {
              "id": "4707",
              "fileName": "【教案】迈好中学第一步.docx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8xOC8xOS81OGE2ZjBmNjY3LTI5ZTEtNGEyYy04NTQxLWE2MzRhNGEwYWM0Ny/jgJDmlZnmoYjjgJHov4jlpb3kuK3lrabnrKzkuIDmraUuZG9jeA==",
              "fileSuffix": "docx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8wMS8yMy81NjQ5MDllYTEyLTI4MjAtNGQxZS1iNzk0LWU0N2M4ZjMwNDFkM19kb2N4YjgxMGFlZWUtOTlkOC00ZjhmLWFhN2YtNDU4NDc0YjUxZmUzLnBkZg==",
              "totalPage": null,
              "convId": "61964382ac98de6a8dcc172d"
            },
            {
              "id": "4708",
              "fileName": "【课件】迈好中学第一步.pptx",
              "filePath": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vQ1NCLWRlY29tcHJlc3Npb24tcGxhbmV0LXNlcnZpY2UvMjAyMS8xMS8wMi8wMC8wODk5N2QyMzRlLTEzOWQtNGYwMi1iMzQ5LWVhZmViM2M5YzYzNi5wcHR4",
              "fileSuffix": "pptx",
              "transformUrl": "aHR0cHM6Ly9iai5kb3dubG9hZC5jeWNvcmUuY24vYWF2cC1maWxlLWNvbnZlcnQtcHJvZC8wODk5N2QyMzRlLTEzOWQtNGYwMi1iMzQ5LWVhZmViM2M5YzYzNi9lNzIyZGE4ZmVhYmQ0NWQ5ODkyZmNmZGVkMmJmYjU1Mi9hZGE4YWFhYTE1Y2E0NmQ1YTc3NTZhNzZmNTEzYWVhZi9wcmVzZW50YXRpb24vZGF0YS9iaWcxLnBuZw==",
              "totalPage": 26,
              "convId": "1be84eea7b2d4c1a944d9fc375e99d3a"
            }
          ]
        }
      }
      if (this.list.zipPath) {
        this.list.zipPath = this.list.zipPath
          ? this.$Base64
            .decode(this.list.zipPath)
            .replace("http://", "https://")
          : null;
      }
      if (this.list.fileVoList.length) {
        this.arrayData = this.list.fileVoList
          ? this.list.fileVoList.map((x) => ({
            ...x,
            fileSuffix: x.fileSuffix
              ? x.fileSuffix
              : this.$Base64
                .decode(x.filePath)
                .substr(
                  this.$Base64.decode(x.filePath).lastIndexOf(".") + 1,
                ),
            filePath: x.filePath
              ? this.$Base64
                .decode(x.filePath)
                .replace("http://", "https://")
              : null,
            transformUrl: x.transformUrl
              ? this.$Base64
                .decode(x.transformUrl)
                .replace("http://", "https://")
              : null,
          }))
          : [];
      }
      if (this.arrayData.length) {

        this.playSourceId = this.arrayData[0].id;
        this.playStartTime = Date.now();

        this.type = this.arrayData[0].fileSuffix;
        if (
          this.arrayData[0].fileSuffix !== "mp4" &&
          this.arrayData[0].fileSuffix !== "MP4" &&
          this.arrayData[0].fileSuffix !== "mov" &&
          this.arrayData[0].fileSuffix !== "MOV" &&
          !this.arrayData[0].transformUrl
        ) {
          this.transcoder = true;
          return false;
        } else {
          this.transcoder = false;
        }
        if (
          this.type === "mp4" ||
          this.type === "MP4" ||
          this.type === "mov" ||
          this.type === "MOV"
        ) {
          this.playerOptions.sources[0].src = this.arrayData[0].filePath;
          this.playerOptions.poster = this.list.coverPath;
        } else if (this.type === "pptx" || this.type === "ppt") {
          this.numPages = this.arrayData[0].totalPage;
          let imgs = this.arrayData[0].transformUrl.substring(
            0,
            this.arrayData[0].transformUrl.length - 5,
          );
          let imgarr = [];
          for (let i = 1; i <= this.arrayData[0].totalPage; i++) {
            let imgUrl = imgs + i + ".png";
            imgarr.push(imgUrl);
          }
          this.pptImg = imgarr;
        } else {
          this.resetPdf = false;
          this.$nextTick(() => {
            this.resetPdf = true;
            let loadingTask;
            if (this.type === "pdf" || this.type === "PDF") {
              this.src = this.arrayData[0].filePath;
              loadingTask = vuePdf.createLoadingTask(this.arrayData[0].filePath);
            } else {
              this.src = this.arrayData[0].transformUrl;
              loadingTask = vuePdf.createLoadingTask(
                this.arrayData[0].transformUrl,
              );
            }
            loadingTask.promise
              .then((pdf) => {
                this.numPages = pdf.numPages;
                this.totalPdf = pdf.numPages > 3 ? 3 : pdf.numPages;
                this.resetPdf = true;
              })
              .catch((err) => {
                console.error("pdf 加载失败", err);
                this.resetPdf = true;
              });
          });
        }
      }
    },
    changePdfPage (val) {
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
      }
    },
    /** @downType 下载类型 1 批量 2单个
     */
    handleDownPackAge () {
      this.downType = 1;
      this.downZips();
    },
    downZips () {

      console.log(this.list);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = this.list.zipPath;
      link.download = `${this.list.courseName}.zip`;
      document.body.appendChild(link);
      link.click();
      this.downType = null;
    },
    // pdf加载时
    loadPdfHandler () {
      this.currentPage = 1;
    },
    handleClick (val, i) {
      // 上报 上个非同id的播放资源 
      // 初始化 当前播放id 播放资源
      const now = Date.now();
      this.playSourceId = val.id;
      this.playStartTime = now;

      this.currentShowIndex = i;
      if (document.getElementById("testScroll")) {
        document.getElementById("testScroll").scrollTop = 0;
      }
      this.type = val.fileSuffix;
      if (
        val.fileSuffix !== "mp4" &&
        val.fileSuffix !== "MP4" &&
        val.fileSuffix !== "mov" &&
        val.fileSuffix !== "MOV" &&
        !val.transformUrl
      ) {
        this.transcoder = true;
        return false;
      } else {
        this.transcoder = false;
      }
      if (
        val.fileSuffix === "mp4" ||
        val.fileSuffix === "MP4" ||
        val.fileSuffix === "mov" ||
        val.fileSuffix === "MOV"
      ) {
        this.playerOptions.sources[0].src = val.filePath;
        this.playerOptions.poster = this.list.coverPath;
      } else if (this.type === "pptx" || this.type === "ppt") {
        this.numPages = val.totalPage;
        let imgs = val.transformUrl.substring(0, val.transformUrl.length - 5);
        let imgarr = [];
        for (let i = 1; i <= val.totalPage; i++) {
          let imgUrl = imgs + i + ".png";
          imgarr.push(imgUrl);
        }
        this.pptImg = imgarr;
      } else {
        this.resetPdf = false;
        this.$nextTick(() => {
          this.resetPdf = true;
          let loadingTask;
          if (val.fileSuffix === "pdf" || val.fileSuffix === "PDF") {
            this.src = val.filePath;
            loadingTask = vuePdf.createLoadingTask(val.filePath);
          } else {
            this.src = val.transformUrl;
            loadingTask = vuePdf.createLoadingTask(val.transformUrl);
          }
          loadingTask.promise
            .then((pdf) => {
              this.numPages = pdf.numPages;
              this.totalPdf = pdf.numPages > 3 ? 3 : pdf.numPages;
              this.resetPdf = true;
              console.log("转码后的数据111");
              console.log(pdf);
            })
            .catch((err) => {
              console.error("pdf 加载失败", err);
              this.resetPdf = true;
            });
        });
      }
    },
    // 单文件下载
    handleDown (val) {
      this.downType = 2;
      this.fileDownVal = val;
      this.downMethods(val);
    },
    downMethods (val) {
      // 点击 下载 资源ID
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = val.filePath;
      link.setAttribute("download", `${val.fileName}`);
      document.body.appendChild(link);
      link.click();
      this.fileDownVal = null;
      this.downType = null;
    },
    handlePlay () { },
    handlePause () { },
    handleEnded () { },
    // 文本转义
    translationContent (val) {
      if (val) {
        return val.replace(/\n|\r\n/g, "<br>");
      }
    },
  },

  beforeDestroy () {

  },
};
</script>

<style lang="scss" scoped>
.breads {
  margin-bottom: 16px;
  font-size: 12px;
  width: 1200px;
  margin: 16px auto;
  overflow: hidden;
  .bread-inner {
    cursor: pointer;
    color: #595959;
    margin-right: 10px;
    padding-right: 10px;
    border-right: 1px solid #dedede;
    &:hover {
      color: #368fff;
    }
  }
  .bread-current {
    color: #262626;
  }
}
.e-content {
  width: 1200px;
  // height: 924px;
  margin: 0 auto;
  .video-container {
    margin-bottom: 16px;
    height: 520px;
    ::v-deep .vjs-big-play-button {
      position: absolute;
      // left: calc(50% - 1.5em);
      // top: calc(50% - 1.5em);
      left: 2%;
      top: 87%;
    }
    .video-docx {
      float: left;
      margin-right: 20px;
      width: 798px;
      height: 100%;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #f0f1f4;

      .title {
        padding: 24px 0 16px 24px;
        font-size: 24px;
        font-weight: 600;
        height: 64px;
        color: #262626;
      }

      .video-player {
        width: 100%;
        height: 450px;
        background: rgba(0, 0, 0, 0.1);

        .video-js .vjs-icon-placeholder {
          width: 100%;
          height: 100%;
          display: block;
        }
        .play-trans {
          width: 100%;
          height: 100%;
          background: #fff;
          text-align: center;
          img {
            margin: 135px 0 4px 0;
          }
          .text {
            font-size: 14px;
            color: #8c8c8c;
          }
        }
        .play-type {
          width: 100%;
          height: 100%;
        }
        .pdf-over {
          overflow-y: auto;
          width: 100%;
          height: 100%;
        }
      }
    }

    .catalogue {
      float: right;
      width: 378px;
      height: 100%;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #f0f1f4;
      overflow: auto;

      .title {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        padding: 24px 24px 0 24px;
        border-bottom: 1px solid #f0f1f4;

        span {
          display: inline-block;
          padding-bottom: 20px;
          font-size: 16px;
          font-weight: 500;
          color: #368fff;
          border-bottom: 2px solid #368fff;
        }

        .btn {
          display: inline-block;
          p {
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #368fff;
            padding: 7px 16px;
            cursor: pointer;
            color: #368fff;
            font-size: 14px;
          }
        }
      }

      .content {
        .list {
          padding: 12px 24px;
          border-bottom: 1px solid #f0f0f0;

          .left {
            display: inline-block;
            width: calc(100% - 40px);
            cursor: pointer;
            .icons {
              vertical-align: middle;
              margin-right: 12px;
              width: 29px;
              height: 33px;
            }

            .text {
              color: #262626;
              font-size: 14px;
              display: inline-block;
              width: 235px;
              vertical-align: bottom;
              line-height: 32px;
            }
          }

          .right {
            display: inline-block;
            text-align: right;
            width: 40px;
            .down {
              cursor: pointer;
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url('~@/assets/images/down.png') no-repeat;
              background-size: 100% 100%;
            }
          }

          &:hover,
          &.active {
            .left {
              .text {
                color: #368fff;
              }
            }
            .right {
              .down {
                background: url('~@/assets/images/down-active.png') no-repeat;
                background-size: 100% 100%;
              }
            }
          }
        }
      }
    }
  }

  .introduction {
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #f0f0f0;

    .introduction-title {
      padding: 20px 24px;
      border-bottom: 1px solid #f0f1f4;
      i {
        display: inline-block;
        vertical-align: text-top;
        width: 6px;
        height: 16px;
        background-color: #368fff;
        border-radius: 2px;
      }

      span {
        margin-left: 8px;
        font-size: 16px;
        color: #262626;
        font-weight: 600;
      }
    }

    .content {
      padding: 0 24px;

      .desc {
        padding: 12px 0;

        .box {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          height: 24px;
          img {
            vertical-align: middle;
            margin-right: 12px;
            width: 20px;
            height: 20px;
          }

          span {
            font-weight: 600;
            color: #262626;
            font-size: 16px;
          }
        }

        p {
          line-height: 22px;
          color: #595959;
          font-size: 14px;
          word-wrap: break-word;
          word-break: normal;
        }
      }
    }
  }
}
.imgbox {
  width: 100%;
  height: 450px;
  overflow-y: scroll;
  img {
    width: 100%;
  }
}
.imgbox::-webkit-scrollbar {
  width: 0px;
}

.description-dialog {
  ::v-deep.el-dialog__header {
    padding: 15px 24px;
  }
  ::v-deep.el-dialog__body {
    padding: 24px 0 0;
  }
  ::v-deep.el-dialog__footer {
    padding: 0;
  }
}
</style>
